export enum PageType {
  Page = 'page',
  Layout = 'layout'
}
